import React from 'react';
import { Stack, UtilityBanner } from '@grubhubprod/gh-cookbook-react';
import { useBalanceContext } from 'src/components/selfService/common/Balance/hooks/useBalanceContext';
import { getActiveBalanceStatusBanner } from 'src/components/selfService/common/Balance/utils/getActiveBalanceStatusBanner/getActiveBalanceStatusBanner';
import { BalanceContextValue } from 'src/components/selfService/common/Balance/balance.types';

const shouldHideBanner = (balanceContext: BalanceContextValue): boolean => {
  return (
    !balanceContext.externalBalanceBuyerId || balanceContext.isCreditInfoLoading
  );
};

export function BalanceStatusSection(): JSX.Element {
  const balanceContext = useBalanceContext();

  if (shouldHideBanner(balanceContext)) {
    return null;
  }

  const balanceBannerData = getActiveBalanceStatusBanner(balanceContext);

  if (!balanceBannerData) {
    return null;
  }

  return (
    <Stack y="lg">
      <UtilityBanner {...balanceBannerData} />
    </Stack>
  );
}
